import { CustomerTheme } from ".";

const theme: CustomerTheme = {
  title: "light",
  colors: {
    primary: "#002951",
    secondary: "#00569A",
    tertiary: "#FF9900",
    background: "white",
    disabled: "#D2D2D2",
    scrollBar: "#F0F0F7",
    text: "black",
    success: "#46c17d",
    error: "#e74c3c"
  }
};

export default theme;
